/**
 * @file audit-report/overall-assessment.ts
 * @description 稽核報告「總體評價」逐項勾選條目定義（客戶序168 有機TOP / 序169-170 產銷履歷TAP）。
 *
 * 需求：總體評價＝【系統默認條目 + 稽核員人工勾選 + 人工填寫】。
 * 各條目為一個單選（符合/不符合等），部分條目附「說明」自由文字。
 * 前端 AuditReportEditor 依 scheme 渲染對應條目，序列化進板塊 markdown。
 */
const YN = ['符合', '不符合'];
const YNN = ['符合', '不符合', '不涉及'];
/** 有機 TOP 總體評價條目（序168，8 大項含平行生產子項） */
export const OVERALL_ITEMS_TOP = [
    { key: 't1', label: '(1)生產場、生產地環境要求有符合驗證標準規範', options: YN },
    {
        key: 't2_1',
        label: '(2-1)有機農產品有機轉型期農產品栽培管理過程（如:病蟲草害防治、有機資材投入及使用等）有符合驗證基準要求',
        options: YN,
    },
    {
        key: 't2_2',
        label: '(2-2)有機農產品有機轉型期農產品加工/分裝/流通產製過程（如:原料配方比例、產製環境條件、有害生物防治等）有符合驗證基準要求',
        options: YN,
    },
    {
        key: 't3',
        label: '(3)有機農產品有機轉型期農產品儲藏、運輸與配售有符合驗證基準要求',
        options: YN,
    },
    { key: 't4', label: '(4)產品檢測結果有符合驗證標準規範', options: YN },
    {
        key: 't5',
        label: '(5)有機農產品有機轉型期農產品包裝、標示及標章管理有符合驗證標準規範',
        options: YN,
    },
    {
        key: 't6',
        label: '(6)有機完整性之相關作業紀錄、衛生管理記錄及單據憑證有符合驗證基準要求',
        options: YN,
    },
    { key: 't6_1', label: '(6-1)若有平行生產之方式，是否有符合驗證基準要求', options: YNN },
    {
        key: 't6_2',
        label: '(6-2)評估平行生產風險(高風險、中風險、低風險)，並簡述說明',
        options: ['高風險', '中風險', '低風險'],
        hasNote: true,
    },
    {
        key: 't7',
        label: '(7)實際稽核作業與稽核計畫之差異，有此情形應說明',
        options: ['涉及', '不涉及'],
        hasNote: true,
    },
    {
        key: 't8',
        label: '(8)以驗證名義申請之驗證批產品，經稽核小組稽核發現其生產、加工、分裝、流通或儲藏作業過程有不符合驗證依據及相關規範要求，不推薦使用驗證標章/發證',
        options: ['不推薦使用驗證標章', '不推薦發證', '不涉及'],
        hasNote: true,
    },
];
/** 產銷履歷 TAP 總體評價條目（序169-170，12 大項含集團驗證子項） */
export const OVERALL_ITEMS_TAP = [
    {
        key: 'p1',
        label: '(1)農產品經營者申請資格、生產場、生產地環境要求有符合驗證標準規範',
        options: YN,
    },
    {
        key: 'p2',
        label: '(2)栽培管理過程（如:病蟲草害防治、資材投入及使用等）有符合驗證基準要求',
        options: YN,
    },
    {
        key: 'p3',
        label: '(3)農產品加工/分裝/流通產製過程（如:原料配方比例、產製環境條件、有害生物防治等）有符合驗證基準要求',
        options: YN,
    },
    { key: 'p4', label: '(4)農產品儲藏、運輸與配售有符合驗證基準要求', options: YN },
    { key: 'p5', label: '(5)產品藥物殘留檢測結果符合我國相關規定', options: YN },
    { key: 'p6', label: '(6)包裝、標示及標章管理有符合驗證標準規範', options: YN },
    { key: 'p7', label: '(7)批次、編碼、追溯作業符合驗證依據及相關規範之規定', options: YNN },
    {
        key: 'p8',
        label: '(8)生產之產銷履歷農產品，其採收總量應逐批於中央主管機關產銷履歷管理資訊系統登載，且是正確且完整之履歷資料',
        options: YN,
    },
    {
        key: 'p9',
        label: '(9)同時進行與非產銷履歷農產品之生產、加工、分裝、流通或儲藏作業時，作物、原料、資材及產品等批次，完全與非產銷履歷農產品區隔，有建立適當的辨識與標示系統，以防止交叉汙染或混雜',
        options: YN,
    },
    {
        key: 'p10',
        label: '(10)實際稽核作業與稽核計畫之差異，有此情形應說明',
        options: ['涉及', '不涉及'],
        hasNote: true,
    },
    {
        key: 'p11',
        label: '(11)以驗證名義申請之驗證批產品，經稽核小組稽核發現其生產、加工、分裝、流通或儲藏作業過程有不符合驗證依據及相關規範要求，不推薦使用驗證標章/發證',
        options: ['不推薦使用驗證標章', '不推薦發證', '不涉及'],
        hasNote: true,
    },
    {
        key: 'p12_1',
        label: '(12-1)※對集團驗證的稽核是否符合相關驗證規範的要求？',
        options: ['是', '否'],
        hasNote: true,
    },
    {
        key: 'p12_2',
        label: '(12-2)※集團總部之運作，是否確認符合其自訂之規範及作業程序規定？',
        options: ['是', '否'],
        hasNote: true,
    },
    {
        key: 'p12_3',
        label: '(12-3)※經確認集團總部運作，並判斷可採抽樣方式辦理各成員實地稽核時，是否抽樣成員數不低於總成員數之平方根？',
        options: ['是', '否', '不涉及'],
        hasNote: true,
    },
    {
        key: 'p12_4',
        label: '(12-4)※承上，採抽樣方式辦理集團成員之實地稽核者，是否就被抽樣成員之所有申請驗證場區進行稽核？',
        options: ['是', '否', '不涉及'],
        hasNote: true,
    },
    {
        key: 'p12_5',
        label: '(12-5)※集團驗證產品抽樣檢驗件數，是否不低於總成員數之平方根？',
        options: ['是', '否'],
        hasNote: true,
    },
];
/** 依方案取得總體評價條目（ECO 回落 TOP） */
export function getOverallAssessmentItems(scheme) {
    return scheme === 'TAP' ? OVERALL_ITEMS_TAP : OVERALL_ITEMS_TOP;
}
/** 總體評價序列化哨兵（純文字，TipTap 編輯保留；round-trip 依此界定生成區） */
export const OVERALL_SENTINEL_START = '【總體評價勾選】';
export const OVERALL_SENTINEL_END = '【總體評價勾選（結束）】';
/**
 * 從 markdown 解析總體評價勾選狀態（讀取哨兵區內的 `- {label}：{value}` 行）。
 * 純函式，便於推理與測試。
 */
export function parseOverallSelections(markdown, items) {
    const result = {};
    const lines = markdown.split('\n');
    const start = lines.indexOf(OVERALL_SENTINEL_START);
    const end = lines.indexOf(OVERALL_SENTINEL_END);
    if (start < 0 || end < 0 || end <= start)
        return result;
    const region = lines.slice(start + 1, end);
    for (const item of items) {
        const line = region.find((l) => l.startsWith(`- ${item.label}：`));
        if (!line)
            continue;
        const value = line.slice(`- ${item.label}：`.length).trim();
        const sel = {};
        if (value && value !== '（未選）')
            sel.value = value;
        if (item.hasNote) {
            const noteLine = region.find((l) => l.startsWith(`  說明（${item.key}）：`));
            if (noteLine) {
                const note = noteLine.slice(`  說明（${item.key}）：`.length).trim();
                if (note)
                    sel.note = note;
            }
        }
        if (sel.value || sel.note)
            result[item.key] = sel;
    }
    return result;
}
/**
 * 將總體評價勾選狀態寫回 markdown：移除既有哨兵區，於內文最前重建。
 * 純函式。
 */
export function applyOverallSelections(markdown, items, selections) {
    const lines = markdown.split('\n');
    const start = lines.indexOf(OVERALL_SENTINEL_START);
    const end = lines.indexOf(OVERALL_SENTINEL_END);
    // 去除既有哨兵區（含首尾空行）
    let body = markdown;
    if (start >= 0 && end >= start) {
        body = [...lines.slice(0, start), ...lines.slice(end + 1)].join('\n').replace(/^\n+/, '');
    }
    const region = [OVERALL_SENTINEL_START];
    for (const item of items) {
        const sel = selections[item.key] ?? {};
        region.push(`- ${item.label}：${sel.value ?? '（未選）'}`);
        if (item.hasNote && sel.note)
            region.push(`  說明（${item.key}）：${sel.note}`);
    }
    region.push(OVERALL_SENTINEL_END);
    return `${region.join('\n')}\n\n${body}`;
}
